import config from 'config';

const LOAD = 'horse-racing/meeting/LOAD';
const LOAD_SUCCESS = 'horse-racing/meeting/LOAD_SUCCESS';
const LOAD_FAIL = 'horse-racing/meeting/LOAD_FAIL';

const initialState = {
  loaded: false
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD:
      return {
        ...state,
        loading: true
      };
    case LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        meeting: action.result
      };
    case LOAD_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      };
    default:
      return state;
  }
}

export function isMeetingLoading(globalState, meetingId) {
  return globalState.horseRacing.meeting
      && globalState.horseRacing.meeting.loading
      && globalState.horseRacing.meeting.meeting
      && globalState.horseRacing.meeting.meeting.id === meetingId;
}

export function load(id) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.horseRacing.loadMeeting}/${id}`)
  };
}

// given a race ID load the corresponding meeting for this race
export function loadMeetingByRaceId(raceId) {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: (client) => client.get(`${config.api.horseRacing.loadMeeting}`, {
      params:{
        raceId
      }
    })
  };
}



// WEBPACK FOOTER //
// ./modules/HorseRacing/reducers/meeting.js